// src/components/RecommendationCard.js
import React from 'react';

const RecommendationCard = ({ title, recommendations }) => {
  return (
    <div className="bg-arc-elevated rounded-lg shadow-md p-6 mb-6">
      <h4 className="text-lg font-medium text-arc-ink mb-4">{title}</h4>
      <ul className="space-y-2">
        {recommendations.map((recommendation, index) => (
          <li key={index} className="flex items-start">
            <svg className="h-5 w-5 text-arc-gold mr-2 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span className="text-arc-muted">{recommendation}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RecommendationCard;